export const DesktopSizeOptions = {
  Title1: `
    font-size: 48px !important;
  `,
  Title2: `
    font-size: 36px !important;
  `,
  Title3: `
    font-size: 30px !important;
  `,
  Title4: `
    font-size: 24px !important;
  `,
  Title5: `
    font-size: 20px !important;
  `,
  caption: `
  font-size: 18px !important;
`,
  caption1: `
  font-size: 16px !important;
`,
  caption2: `
  font-size: 14px !important;
`,
  caption3: `
  font-size: 12px !important;
`,
};

export const MobileSizeOptions = {
  Title1: `
    font-size: 30px !important;
  `,
  Title2: `
    font-size: 24px !important;
  `,
  Title3: `
    font-size: 22px !important;
  `,
  Title4: `
    font-size: 20px !important;
  `,
  Title5: `
    font-size: 18px !important;
  `,
  caption: `
  font-size: 16px !important;
`,
  caption1: `
  font-size: 16px !important;
`,
  caption2: `
  font-size: 14px !important;
`,
  caption3: `
  font-size: 12px !important;
`,
};

export const WeightOptions = {
  Light: `
    font-weight: 300 !important;
  `,
  Regular: `
    font-weight: 400 !important;
  `,
  SemiBold: `
   font-weight: 600 !important;
  `,
  Bold: `
  font-weight: 700 !important;
  `,
  Black: `
    font-weight: 900 !important;
  `,
};

export type TypographySizeOptions =
  | keyof typeof DesktopSizeOptions
  | keyof typeof MobileSizeOptions;

export type TypographyWeightOptions = keyof typeof WeightOptions;
